





































import { OkihaiPlace } from '@/models/delivery'
import { PluginMixin } from '@spa/mixins/plugin'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

@Component
export default class SelectOkihaiPlace extends Mixins<PluginMixin>(
  PluginMixin
) {
  @Prop({ required: true })
  optionList: OkihaiPlace[]

  /**
   * 選択中の置き配場所のID。未選択の場合はnull
   */
  @Prop({ required: true })
  value: string | null

  onChange(event) {
    const selectedPlace = this.optionList.find(place => place.id === event.target.value)
    if (!selectedPlace) {
      throw new Error(`Selected okihai place not found, ID = ${event.target.value}`)
    }

    this.changeOkihaiPlace(selectedPlace)
  }

  @Emit('change-okihai-place')
  changeOkihaiPlace(_okihaiPlace: OkihaiPlace) {
    // do nothing
  }
}
